export default __webpack_public_path__ + "static/media/arrow_back.8e6bd5e9.svg";